export default "__VITE_ASSET__Dc65$3Nt__"